import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { GotoInteractionAction } from '../../../../../models/interactions.model';

@Component({
  selector: 'app-goto-interaction-action',
  imports: [MatIcon, MatTooltip, CdkDragHandle, NgTemplateOutlet],
  templateUrl: './goto-interaction-action.component.html',
  styleUrl: './goto-interaction-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GotoInteractionActionComponent {
  public readonly data = input.required<GotoInteractionAction>();
  public readonly actions = input<TemplateRef<unknown>>();
}
